import createReactComponent from '../createReactComponent';
export default createReactComponent('message-report', 'IconMessageReport', [
  [
    'path',
    {
      d: 'M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M12 8l0 3', key: 'svg-1' }],
  ['path', { d: 'M12 14l0 .01', key: 'svg-2' }],
]);
